export default {
  greeting: 'Le Welcome'
};
